import { render, staticRenderFns } from "./newbieGift.vue?vue&type=template&id=02018cde&scoped=true"
import script from "./newbieGift.vue?vue&type=script&lang=js"
export * from "./newbieGift.vue?vue&type=script&lang=js"
import style0 from "./newbieGift.vue?vue&type=style&index=0&id=02018cde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02018cde",
  null
  
)

export default component.exports